import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["userType", "organizationContainer"]
  
  get visibleOrganizationContainer() {
    // Find the visible organization container based on the selected user type
    const userType = this.userTypeTarget.value
    if (!userType) return this.organizationContainerTarget
    
    // Look for the container in the visible user type section
    const visibleSection = this.element.querySelector(`[data-user-type="${userType}"]:not([style*="display: none"])`)
    if (visibleSection) {
      const container = visibleSection.querySelector('[data-dynamic-organization-target="organizationContainer"]')
      if (container) return container
    }
    
    // Fallback to the first container
    return this.organizationContainerTarget
  }
  static values = { url: String }

  connect() {
    // Load organizations for initially selected user type if any
    if (this.userTypeTarget.value) {
      this.loadOrganizations()
    }
  }

  userTypeChanged() {
    this.loadOrganizations()
  }

  async loadOrganizations() {
    const userType = this.userTypeTarget.value
    const container = this.visibleOrganizationContainer
    
    if (!userType) {
      container.innerHTML = this.getEmptyOrganizationSelect()
      return
    }

    // Check if this is a bulk invite form by looking for the bulk invitations textarea
    // or by checking if we're in a bulk tab panel
    const isBulkForm = this.element.querySelector('[name="bulk_invitations"]') !== null ||
                       this.element.closest('[data-panel="bulk"]') !== null

    try {
      const url = isBulkForm 
        ? `${this.urlValue}?user_type=${userType}&bulk=true`
        : `${this.urlValue}?user_type=${userType}`
        
      const response = await fetch(url, {
        headers: {
          "Accept": "text/html",
          "X-Requested-With": "XMLHttpRequest"
        }
      })

      if (response.ok) {
        const html = await response.text()
        container.innerHTML = html
      } else {
        console.error("Failed to load organizations:", response.statusText)
        container.innerHTML = this.getErrorOrganizationSelect()
      }
    } catch (error) {
      console.error("Error loading organizations:", error)
      container.innerHTML = this.getErrorOrganizationSelect()
    }
  }

  getEmptyOrganizationSelect() {
    return `
      <div class="form-group">
        <label class="block text-sm font-medium text-gray-700">Organization</label>
        <div class="mt-1">
          <select class="block w-full px-3 py-2 border border-gray-300 rounded-md shadow-xs focus:outline-hidden focus:ring-primary focus:border-primary sm:text-sm bg-gray-50" disabled>
            <option>Select user type first</option>
          </select>
        </div>
        <p class="mt-1 text-xs text-gray-500">Choose a user type to see available organizations</p>
      </div>
    `
  }

  getErrorOrganizationSelect() {
    return `
      <div class="form-group">
        <label class="block text-sm font-medium text-gray-700">Organization</label>
        <div class="mt-1">
          <select class="block w-full px-3 py-2 border border-red-300 rounded-md shadow-xs focus:outline-hidden focus:ring-red-500 focus:border-red-500 sm:text-sm bg-red-50" disabled>
            <option>Error loading organizations</option>
          </select>
        </div>
        <p class="mt-1 text-xs text-red-500">Please refresh the page and try again</p>
      </div>
    `
  }
}